// Custom edge hover renderer for Sigma.js that ensures highlighted edges render above nodes
//
// This renderer is called AFTER nodes are drawn, allowing us to draw highlighted edges
// on top of faded/non-highlighted nodes.
import { getTheme, THEMES } from '../../../lib/themeManager';

/**
 * Draw highlighted (hovered or selected) edges on top of all nodes
 *
 * This is called in the hover rendering pass, which happens AFTER normal edge and node rendering.
 * By redrawing highlighted edges here, we ensure they appear above faded nodes.
 */
export function drawHoveredEdgeLabel(edgeDisplayData, data, sourceData, targetData, context, settings) {
  const { highlighted } = data;

  // Only draw if this edge is highlighted (hovered or selected)
  if (!highlighted) {
    return;
  }

  // Get edge styling from data (set by edgeReducer)
  const { color, size } = data;

  // Draw the edge line on top of everything
  context.strokeStyle = color || "#C09055"; // Default to hover color
  context.lineWidth = size || 6;
  context.globalAlpha = 1.0; // Full opacity for highlighted edges

  context.beginPath();
  context.moveTo(sourceData.x, sourceData.y);
  context.lineTo(targetData.x, targetData.y);
  context.stroke();

  // If edge has a label, draw it
  if (data.label && data.forceLabel) {
    const midX = (sourceData.x + targetData.x) / 2;
    const midY = (sourceData.y + targetData.y) / 2;

    // Detect dark mode and set appropriate label color
    const isDarkMode = getTheme() === THEMES.DARK;
    const labelColor = isDarkMode ? "#e0e0e0" : "#000";

    const fontSize = settings.edgeLabelSize || settings.labelSize || 12;
    context.fillStyle = labelColor;
    context.font = `${fontSize}px sans-serif`;
    context.textAlign = "center";
    context.textBaseline = "middle";

    // Draw label background for readability
    const metrics = context.measureText(data.label);
    const padding = 2;
    context.fillStyle = "rgba(255, 255, 255, 0.9)"; // White background
    context.fillRect(
      midX - metrics.width / 2 - padding,
      midY - fontSize / 2 - padding,
      metrics.width + 2 * padding,
      fontSize + 2 * padding
    );

    // Draw label text
    context.fillStyle = labelColor;
    context.fillText(data.label, midX, midY);
  }
}